import { render, staticRenderFns } from "./ModalPremiumComment.vue?vue&type=template&id=dfae984c&scoped=true&"
import script from "./ModalPremiumComment.vue?vue&type=script&lang=js&"
export * from "./ModalPremiumComment.vue?vue&type=script&lang=js&"
import style0 from "./ModalPremiumComment.vue?vue&type=style&index=0&id=dfae984c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfae984c",
  null
  
)

export default component.exports